export default "__VITE_ASSET__00bce2c4__"